export default function TemplateIcon(props: Icon) {
  const { height, width } = props;
  return (
    <svg
      aria-hidden="true"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      width={width ? width : height ? height : 18}
      height={height ? height : width ? width : 18}
      viewBox="0 96 960 960"
    >
      <path
        fill="currentColor"
        d="M309.826 774.174h215q12.185 0 21.093-8.676 8.907-8.675 8.907-21.5 0-12.259-8.907-21.042-8.908-8.782-21.093-8.782h-215q-12.75 0-21.375 8.958t-8.625 21.5q0 12.542 8.625 21.042 8.625 8.5 21.375 8.5Zm0-168.174h340.913q12.185 0 21.092-8.675 8.908-8.676 8.908-21.5 0-12.825-8.908-21.325-8.907-8.5-21.092-8.5H309.826q-12.75 0-21.375 8.675-8.625 8.676-8.625 21.5 0 12.825 8.625 21.325t21.375 8.5Zm.189-168.739h340.724q12.185 0 21.092-8.675 8.908-8.676 8.908-21.5 0-12.26-8.908-21.042-8.907-8.783-21.092-8.783H310.015q-12.83 0-21.51 8.958-8.679 8.958-8.679 21.5t8.679 21.042q8.68 8.5 21.51 8.5Zm-124.928 512.87q-32.507 0-55.862-23.356-23.356-23.355-23.356-55.862V281.087q0-32.74 23.356-56.262 23.355-23.521 55.862-23.521h589.826q32.74 0 56.262 23.521 23.521 23.522 23.521 56.262v589.826q0 32.507-23.521 55.862-23.522 23.356-56.262 23.356H185.087Zm0-79.218h589.826V281.087H185.087v589.826Zm0-589.826v589.826-589.826Z"
      />
    </svg>
  );
}
